export interface FooterPopularLinks {
  name: string;
  link: string;
}

const footerPopularLinksConfig = (state: FooterPopularLinks[] = []) => state;

export default footerPopularLinksConfig;
